module.exports = __webpack_public_path__ + "img/multiple-checkboxes.549f7459.svg";